var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "z-switch", attrs: { for: _vm.id } }, [
    _c("span", { staticClass: "z-switch__view" }, [
      _vm.changed
        ? _c(
            "span",
            { staticClass: "z-switch__view-item" },
            [_vm._t("left")],
            2
          )
        : !_vm.changed
        ? _c(
            "span",
            { staticClass: "z-switch__view-item" },
            [_vm._t("right")],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "z-switch__controls" }, [
      _c(
        "span",
        {
          staticClass: "z-switch__item",
          class: { "z-switch__item--disabled": _vm.disabled },
        },
        [
          _c("span", { staticClass: "z-switch__wrapper" }, [
            _c("input", {
              staticClass: "z-switch__input",
              attrs: {
                type: "checkbox",
                name: _vm.id,
                id: _vm.id,
                disabled: _vm.disabled,
              },
              domProps: { checked: _vm.changed },
              on: {
                change: function ($event) {
                  return _vm.onChange($event.target.checked)
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "z-switch__slide" }),
          ]),
          _vm._v(" "),
          _c("span", {
            staticClass: "z-switch__text",
            domProps: { innerHTML: _vm._s(_vm.title) },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }